
import { useEffect, useCallback } from "react";

export const useContentRecovery = (
  recoverSession: () => Promise<boolean>,
  recoveryAttempts: number,
  setRecoveryAttempts: (attempts: number) => void,
  MAX_RECOVERY_ATTEMPTS: number
) => {
  const checkContent = useCallback(async () => {
    const mainContent = document.querySelector('.min-h-screen');
    if (!mainContent || !mainContent.children.length) {
      if (recoveryAttempts < MAX_RECOVERY_ATTEMPTS) {
        setRecoveryAttempts(recoveryAttempts + 1);
        const recovered = await recoverSession();
        
        if (!recovered && recoveryAttempts === MAX_RECOVERY_ATTEMPTS - 1) {
          window.location.reload();
        }
      }
    }
  }, [recoverSession, recoveryAttempts, setRecoveryAttempts, MAX_RECOVERY_ATTEMPTS]);

  useEffect(() => {
    const timeoutId = setTimeout(checkContent, 1000);
    return () => clearTimeout(timeoutId);
  }, [checkContent]);
};
